module.exports = __webpack_public_path__ + "static/media/bulkPlus.984d3d07.svg";